import React from 'react'
import './loader.css';

const LoaderOverlay = () => (
  <div className='spinner-overlay'>
    <img
      src="/favicon.ico"
      alt="Cargando..."
      className="spinner-imagen"
    />
  </div>
);

export default LoaderOverlay;